export default __webpack_public_path__ + "static/3drender-fe0a4ff48ca4b3fa4a49a89dba9524fe.png";